/** Console logging for local debugging only (no-op in production builds). */
export function devLog(...args) {
	if (import.meta.env.DEV) {
		console.log(...args)
	}
}
